export const PLAN_LIMITS = {
  free:    { proposals_per_month: 3,  invoices_per_month: 3,  projects: 2,  clients: 5,  templates: 1  },
  pro:     { proposals_per_month: 50, invoices_per_month: 50, projects: 25, clients: 50, templates: 10 },
  premium: { proposals_per_month: -1, invoices_per_month: -1, projects: -1, clients: -1, templates: -1 },
};

// Prices mirror backend/src/planLimits.ts PLAN_PRICES (USD, stored there in cents).
export const PLANS = [
  {
    key: 'free',
    name: 'Free',
    price: 0,
    currency: '$',
    period: '/month',
    description: 'For getting started',
    features: [
      '3 proposals/month',
      '3 invoices/month',
      '2 projects',
      '5 clients',
      '1 template',
    ],
    cta: 'Current Plan',
  },
  {
    key: 'pro',
    name: 'Pro',
    price: 20,
    currency: '$',
    period: '/month',
    description: 'For growing freelancers',
    features: [
      '50 proposals/month',
      '50 invoices/month',
      '25 projects',
      '50 clients',
      '10 templates',
      'Priority support',
    ],
    cta: 'Upgrade to Pro',
    popular: true,
  },
  {
    key: 'premium',
    name: 'Premium',
    price: 45,
    currency: '$',
    period: '/month',
    description: 'For established professionals',
    features: [
      'Unlimited proposals',
      'Unlimited invoices',
      'Unlimited projects',
      'Unlimited clients',
      'Unlimited templates',
      'Priority support',
      'Custom branding',
    ],
    cta: 'Upgrade to Premium',
  },
];

export function formatLimit(value) {
  return value === -1 ? 'Unlimited' : value;
}
